
import { defineComponent, onMounted, computed, ref } from 'vue'
import LayoutsAuth from '@/layouts/Auth.vue'
import { useStore } from '@/store/index'
import { dayjs } from '@/plugins/dayjs'
import { toArray } from '@/utils/array'
import BasePagination from '@/components/BasePagination.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuth, BasePagination, LayoutsAuthWidth },
  setup() {
    const store = useStore()
    const notices = computed(() => store.state.notice.notices)
    const pageSize = ref(10)
    const pagedList = ref([])

    onMounted(() => {
      store.dispatch('notice/fetchNotices')
    })

    return {
      dayjs,
      store,
      notices,
      toArray,
      pageSize,
      pagedList
    }
  }
})
